"use client";

import axios from "axios";

import { toast } from "react-toastify";

import { useEffect, useState } from "react";
import { INITIATE_DATA, EMAIL_VALIDATE } from "../utils/constants";

import { funcValidateEmail, funcValidateMessage, funcValidateSubject } from "../utils/regexValidate";
import { getAxiosErrorMessage } from "../utils/funcErrorMessageCatch";
import { useTranslation } from "react-i18next";
import { ENDPOINT_CHECKED_SHARE_IN } from "../api/urls";

interface SendMailComponentProps {
  uid: string | "";
  token : string | "";
  cemail: string | "";
}

const SendMailComponent: React.FC<SendMailComponentProps> = ({ uid, token, cemail }) => {

        const { t } = useTranslation();

        const [formData, setFormData] = useState(INITIATE_DATA);
        const [errors, setErrors] = useState(EMAIL_VALIDATE);
        const [, setLoading] = useState(false);

        const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                const { name, value } = e.target;
                setFormData((prev) => ({ ...prev, [name]: value }));
        };

        const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                const { name, value } = e.target;

                if (name === "receiver_email") setErrors((prev) => ({...prev, emailTo: value ? !funcValidateEmail(value) : false }));
                
                if (name === "sender_email") setErrors((prev) => ({...prev, yourEmail: value ? !funcValidateEmail(value) : false }));
                
                if (name === "email_subject") setErrors((prev) => ({...prev, subjectLine: value ? !funcValidateSubject(value) : false }));
                
                if (name === "email_body") setErrors((prev) => ({...prev, messageContent: value ? !funcValidateMessage(value) : false }));

        };

        useEffect(()=>{
                setFormData((prev) => ({ ...prev, share_uid: uid }));
        },[uid])

        const handleSubmit = async (e: React.FormEvent) => {
                e.preventDefault();
                
                if (Object.values(formData).some((val) => val === "")) {
                        toast.error(t("key_error_toast_complete_all_fields"));
                        return;
                }

                if (Object.values(errors).some((val) => val === true)) {
                        toast.error(t("key_error_toast_values_fields"));
                        return;
                }

                try {
                        let resp = await axios.post(ENDPOINT_CHECKED_SHARE_IN,
                                formData
                                ,{ headers: { "Content-Type": "application/json", Authorization : `Bearer ${token}` } }
                        );

                        if (resp?.status !== 200) toast.error(t('key_error_toast_send_mail'));

                        toast.success(`${t("key_success_toast_thank_choosing")}`);
                        setFormData(INITIATE_DATA);

                } catch (err) {
                        toast.error(`${t("key_error_toast_something_wrong")} ! ${getAxiosErrorMessage(err)}`);
                } finally {
                        setLoading(false);
                }
        };

        return (
                <div className="mt-6 lg:px-[10%] md:px-2 relative flex flex-col gap-2">
                        <p>{t("key_flow_bymail_title")}</p>

                        <form method="post" onSubmit={handleSubmit} className="my-2">
                                <div className="bg-white text-gray-700 rounded-lg flex flex-col gap-4 px-10 py-12">
                                        <input type="text" value={formData.receiver_email} onChange={handleChange} onBlur={handleBlur} name="receiver_email" placeholder={t("key_flow_bymail_placeholder_to")} className={`outline-none py-2 border-b text-lg ${errors.emailTo ? "border-red-500" : "border-gray-500"}`} />
                                        { errors.emailTo && <p className="text-red-500 text-sm mt-1">{t("key_error_email_invalid")}</p> }

                                        <input type="text" value={formData.sender_email} onChange={handleChange} onBlur={handleBlur} name="sender_email" placeholder={t("key_flow_bymail_placeholder_from")} className={`outline-none py-2 border-b text-lg ${errors.yourEmail ? "border-red-500" : "border-gray-500"}`} />
                                        { errors.yourEmail && <p className="text-red-500 text-sm mt-1">{t("key_error_email_invalid")}</p> }

                                        <input type="text" value={formData.email_subject} onChange={handleChange} onBlur={handleBlur} name="email_subject" placeholder={t("key_flow_bymail_placeholder_subject")} className={`outline-none py-2 border-b text-lg ${errors.subjectLine ? "border-red-500" : "border-gray-500"}`} />
                                        { errors.subjectLine && <p className="text-red-500 text-sm mt-1">{t("key_error_subject")} {formData.email_subject.length} {t("key_error_field_characters")} !</p> }

                                        <textarea value={formData.email_body} onChange={handleChange} onBlur={handleBlur} name="email_body" placeholder={t("key_flow_bymail_placeholder_message")} maxLength={260} className={`resize-none outline-none py-2 border-b text-lg ${errors.messageContent ? "border-red-500" : "border-gray-500"}`}></textarea>
                                        { errors.messageContent && <p className="text-red-500 text-sm mt-1">{t("key_error_textarea")} {formData.email_body.length} {t("key_error_field_characters")} !</p> }

                                </div>

                                <button type="submit" 
                                        className={`w-full text-center rounded-lg outline-none p-4 font-bold text-sm mt-10 text-white bg-blue-600 hover:bg-blue-700 }`}>
                                        {t("key_flow_bymail_btn")}
                                </button>

                        </form>
                </div>
        );
}

export default SendMailComponent;
